module.exports = __webpack_public_path__ + "img/DeskeraCRM.db34dad8.svg";